import { useQuery } from "@tanstack/react-query";
import { readSuperusersSuperusersGet } from "@/client-admin";
import { LoadingComponent } from "@/components/LoadingComponent";
import { columns } from "./columns";
import { DataTable } from "./data-table";

export function SuperUsersTable() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["superusers"],
    queryFn: () => readSuperusersSuperusersGet(),
  });

  if (isLoading) return <LoadingComponent />;
  if (isError) return <div>Error loading superusers</div>;
  if (!data) return <div>Data not loaded</div>;

  return <DataTable columns={columns} data={data.data} />;
}
